// extracted by mini-css-extract-plugin
export var callCard = "_p9-0";
export var callMessageButton = "_p9-1";
export var helpIcon = "_p9-3";
export var helpIconContainer = "_p9-4";
export var verticalDivider = "_p9-2";